import moment from 'moment';

export default [
	[
		{
			index: 'id',
			header: {
				title: 'ID'
			},
			column: {}
		},
		{
			index: 'name_en',
			header: {
				title: 'name (EN)'
			},
			column: {}
		},
		{
			index: 'name_ru',
			header: {
				title: 'name (RU)'
			},
			column: {}
		},
		{
			index: 'created_at',
			header: {
				title: 'created at'
			},
			column: {
				format: v => moment(v).format('DD.MM.YYYY HH:mm')
			}
		},
		{
			index: 'actions',
			header: {
				title: 'actions'
			},
			column: {}
		}
	]
];


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/programs/category/list/table-initial-data.js